import { z } from 'zod';
import { paginatedSchema, paginationQuerySchema } from './pagination';

// ---------------------------------------------------------------------------------------------
// Central de notificações e menções (T-113, RF-42; DEC-048).

export const NOTIFICATION_KINDS = [
  'MENTION',
  'TARGET_DECISION',
  'ALERT',
  'ALERT_STATUS',
  'DECISION_APPROVAL',
  'DECISION_APPROVAL_RESULT',
] as const;
export type NotificationKindName = (typeof NOTIFICATION_KINDS)[number];
export const NOTIFICATION_KIND_LABELS: Record<NotificationKindName, string> = {
  MENTION: 'Menção',
  TARGET_DECISION: 'Metas',
  ALERT: 'Alerta',
  ALERT_STATUS: 'Alerta',
  DECISION_APPROVAL: 'Aprovação',
  DECISION_APPROVAL_RESULT: 'Aprovação',
};

export const notificationSchema = z.object({
  id: z.string().uuid(),
  kind: z.enum(NOTIFICATION_KINDS),
  title: z.string(),
  body: z.string().nullable(),
  /** Caminho na aplicação para abrir o assunto. */
  link: z.string(),
  actorName: z.string().nullable(),
  /** Em destaque (ex.: alerta de criticidade alta ou crítica). */
  important: z.boolean(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});
export type Notification = z.infer<typeof notificationSchema>;

export const notificationListSchema = paginatedSchema(notificationSchema).extend({
  /** Não lidas da pessoa (todas, não só as da página). */
  unread: z.number().int(),
});
export type NotificationList = z.infer<typeof notificationListSchema>;

export const notificationListQuerySchema = paginationQuerySchema.extend({
  unread: z.enum(['true', 'false']).optional(),
});
export type NotificationListQuery = z.input<typeof notificationListQuerySchema>;

export const notificationUnreadSchema = z.object({ unread: z.number().int() });
/** Resposta de "marcar todas como lidas": quantas foram marcadas. */
export const notificationReadAllSchema = notificationUnreadSchema.extend({ marked: z.number().int() });

export const notificationPreferencesSchema = z.object({
  /** E-mail quando alguém me menciona (padrão ligado). */
  emailMentions: z.boolean(),
});
export type NotificationPreferences = z.infer<typeof notificationPreferencesSchema>;

/** Pessoas que podem ser mencionadas num comentário (enxergam o assunto). */
export const mentionableSchema = z.object({
  items: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
});
export type Mentionable = z.infer<typeof mentionableSchema>;
export const MENTIONS_MAX = 20;
